/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */function isHostComponent(element){return typeof element==='string';}export default isHostComponent;